// extracted by mini-css-extract-plugin
export default {"modal_cls_btn":"Button_modal_cls_btn__NQZ5N","add_btn":"Button_add_btn__C0TBz","save_btn":"Button_save_btn__aTg+V","icon_button":"Button_icon_button__hZcZX"};